// Mirror of the API's src/constants/sah_budgets.mjs (TAV-2601 / TAV-2602).
//
// SA's Budgets 1.3.0 spec declares status as 'Open' / 'Closed', but the LIVE API returns 'OPEN'
// (12/12 budgets in .claude/tasks/TAV-2599/live-budgets-capture.json). 'CLOSED' has never been
// observed live - it is inferred by symmetry. The API's refresh path writes SA's value verbatim,
// so the local field holds whatever SA sent. Read case-insensitively so the gate survives either
// casing; write our own constant so the value we set is never a guess.
export const BUDGET_STATUS_OPEN = 'OPEN';
export const BUDGET_STATUS_CLOSED = 'CLOSED';
export const BUDGET_TYPE_CODE_COMMONWEALTH_UNSPENT = 'CU';

export const isBudgetOpen = (status?: string | null): boolean =>
  String(status ?? '').toUpperCase() === BUDGET_STATUS_OPEN;

// Case-insensitive for the same reason as isBudgetOpen, but on weaker evidence: the live capture
// (.claude/tasks/TAV-2599/live-budgets-capture.json) holds 12 budgets, all 'ON', so we know type
// codes arrive uppercase but have never seen a 'CU' one - no CU budget exists in the vendor
// environment (see the MR notes). A casing mismatch here would fail closed and SILENTLY: the
// elect-to-return action would simply never appear for a genuinely eligible budget, with no error
// anywhere, until a real provider needed to return funds and could not.
export const isCommonwealthUnspent = (budgetTypeCode?: string | null): boolean =>
  String(budgetTypeCode ?? '').toUpperCase() === BUDGET_TYPE_CODE_COMMONWEALTH_UNSPENT;
